import DisabledChip from "../DisabledChip"
import ImageBackground from "./components/ImageBackground"
import SocialProfile from "./components/SocialProfile"
import Grid from "@mui/material/Grid"
import Typography from "@mui/material/Typography"
import { AuthDialog } from "app-constants/constants"
import { FavoriteButton } from "components/buttons/FavoriteButton"
import useAuthRedirect from "hooks/useAuthRedirect"
import useHeadingStyles from "hooks/useHeadingStyles"
import { useState, useEffect } from "react"
import { makeStyles } from "tss-react/mui-compat"

const useStyles = makeStyles()(
  (theme) => ({
    root: {
      padding: 0,
    },
    logoBox: {
      padding: "20px",
    },
    subtitle: {
      fontSize: "18px",
      color: "#262B2D",
      fontFamily: "Lato",
      letterSpacing: "0.3px",
      lineHeight: "22px",
    },
    imageGridContainer: {
      width: "100%",
    },
    imageDiv: {
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-end",
      justifyContent: "flex-end",
      alignSelf: "flex-end",
      [theme.breakpoints.down("xl")]: {
        justifyContent: "flex-start",
        marginTop: "10px",
        marginLeft: "-10px",
        width: "100%",
        flexWrap: "wrap",
      },
      [theme.breakpoints.up("md")]: {
        marginRight: "-20px",
      },
    },
  })
)

interface IProfileHeader {
  title: string
  subtitle: string
  images: any[]
  disabled: boolean
  isFavorite: boolean
  socialLink: any[]
  onRightIconPress: (e: React.MouseEvent) => void
}

const ProfileHeader = (props: IProfileHeader) => {
  const {
    title,
    subtitle,
    images,
    disabled,
    isFavorite: defaultIsFavorite,
    socialLink,
    onRightIconPress,
  } = props

  const authRedirect = useAuthRedirect({
    defaultDialog: { dialog: AuthDialog.JOIN, payload: { preamble: '', dialogHeader: 'Sign In' }},
  })
  const [isFavorite, setIsFavorite] = useState(defaultIsFavorite)

  const { classes } = useStyles()
  const { classes: headingClasses } = useHeadingStyles()

  useEffect(() => {
    setIsFavorite(defaultIsFavorite)
  }, [defaultIsFavorite])

  // @ts-ignore PT - #180597146
  const onRightPress = (evt) =>
    authRedirect(() => {
      setIsFavorite(!isFavorite)
      onRightIconPress(evt)
    })
  // @ts-ignore PT - #180597146
  const getSocialLinkByType = (linkType) => {
    const socialProfile = socialLink.find((e) => e.link_type === linkType.trim())
    return socialProfile?.value
  }
  // @ts-ignore PT - #180597146
  const getSocialHandleByType = (linkType) => {
    const socialProfile = socialLink.find((e) => e.link_type === linkType.trim())
    let socialProfileLink
    if (linkType === "instagram" && socialProfile?.value) {
      socialProfileLink = `//www.instagram.com/${socialProfile?.value}`
    }
    if (linkType === "snapchat" && socialProfile?.value) {
      socialProfileLink = `//www.snapchat.com/add/${socialProfile?.value}`
    }
    if (linkType === "tiktok" && socialProfile?.value) {
      socialProfileLink = `//www.tiktok.com/@${socialProfile?.value}`
    }
    return socialProfileLink
  }
  const socialLinkConfigs = [
    {
      name: "facebook",
      link: getSocialLinkByType("facebook"),
      icon: "/assets/social-icons/facebook-icon-48.png",
      ariaLabel: `${title} Facebook Profile`,
    },
    {
      name: "instagram",
      link: getSocialHandleByType("instagram"),
      icon: "/assets/social-icons/instagram-icon-48.png",
      ariaLabel: `${title} Instagram Profile`,
    },
    {
      name: "linkedin",
      link: getSocialLinkByType("linkedin"),
      icon: "/assets/social-icons/linkedin-icon-48.png",
      ariaLabel: `${title} Linkedin Profile`,
    },
    {
      name: "snapchat",
      link: getSocialHandleByType("snapchat"),
      icon: "/assets/social-icons/snapchat-icon-48.png",
      ariaLabel: `${title} Snapchat Profile`,
    },
    {
      name: "tiktok",
      link: getSocialHandleByType("tiktok"),
      icon: "/assets/social-icons/tiktok-icon-48.png",
      ariaLabel: `${title} TikTok Profile`,
    },
    {
      name: "twitter",
      link: getSocialLinkByType("twitter"),
      icon: "/assets/social-icons/twitter-icon-48.png",
      ariaLabel: `${title} Twitter Profile`,
    },
    {
      name: "website",
      link: getSocialLinkByType("website"),
      icon: "/assets/social-icons/website-icon-48.png",
      ariaLabel: `${title} Website`,
    },
    {
      name: "youtube",
      link: getSocialLinkByType("youtube"),
      icon: "/assets/social-icons/youtube-icon-48.png",
      ariaLabel: `${title} Youtube Profile`,
    },
  ]

  if (images.length === 0) {
    return <></>
  }
  // else if (images.length === 1) {
  else {
    return (
      <>
        <ImageBackground url={images[0]}>
          {disabled ? (
            <DisabledChip />
          ) : (
            <FavoriteButton isFavorite={isFavorite} name={title} onClick={onRightPress} />
          )}
        </ImageBackground>
        <Grid container className={classes.logoBox}>
          <Grid item xs={12} md={9}>
            <Typography className={classes.subtitle}>{subtitle}</Typography>
            <Typography variant="h1" className={headingClasses.newh1}>
              {title}
            </Typography>
          </Grid>
          <Grid item md={3} className={classes.imageGridContainer}>
            <div className={classes.imageDiv}>
              {socialLinkConfigs.map((socialLink) => {
                {
                  return (
                    socialLink.link && (
                      <SocialProfile
                        key={socialLink.link}
                        socialLink={socialLink.link}
                        profileUrlLabel={socialLink.ariaLabel}
                        socialIcon={socialLink.icon}
                      />
                    )
                  )
                }
              })}
            </div>
          </Grid>
        </Grid>
      </>
    )
  }
  //else {}
}

export default ProfileHeader
